import {Button, Card} from "antd";
import {useEffect, useRef, useState} from "react";
import ApiService from "../services/ApiService";
import TinymceEditor from "../components/TinymceEditor";

export default function HelpContentPage() {
    const [helpContent, setHelpContent] = useState('')
    const helpContentRef = useRef('')

    const getInfo = async () => {
        const res = await ApiService.RasCheck.GetHelpContent();
        if(res.success) {
            setHelpContent(res.data)
            helpContentRef.current = res.data
        }
    }

    useEffect(() => {
        getInfo()
    }, []);

    return (
        <Card
            title={'Help Content'}
            style={{margin: 16}}
        >
            <div style={{display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16}}>
                <Button
                    type={'primary'}
                    onClick={async () => {
                        const res = await ApiService.RasCheck.SaveHelpContent(helpContentRef.current)
                        if (res.success) {

                        }
                    }}
                >
                    Save
                </Button>
            </div>
            <TinymceEditor
                height={'60vh'}
                value={helpContent}
                handleChange={(val) => {
                    helpContentRef.current = val
                }}
            />
        </Card>
    )
}